import React, { useEffect } from 'react'
import { CourseMainBox } from './styles'
import { BasicsStep } from './Steps/basicsStep'
import { LearningObjectives } from './Steps/learningObjectives'
import { Curriculum } from './Steps/curriculum'
import { ClassSchedule } from './Steps/classSchedule'
import { Summary } from './Steps/summary'
import { useSelector } from 'react-redux'
import { CourseDetails } from './Steps/courseDetails'
import { useNavigate } from 'react-router-dom'
import paths from '../../Infrastructure/Router/paths'

export const CourseCreationFlow = () => {
    const navigate = useNavigate()
    const course = useSelector((state) => state.course.courseDetails)
    const courseSteps = useSelector((state) => state.courseSteps.courseSteps)
    useEffect(() => {
        if (course?.course?.status && course.course.status !== "in_progress") {
            navigate(paths.dashboardPage.path);
        }
    }, [course, navigate]);
    return (
        <>
            <CourseMainBox>
                {courseSteps === 1 && <BasicsStep />}
                {courseSteps === 2 && <LearningObjectives />}
                {courseSteps === 3 && <Curriculum />}
                {courseSteps === 4 && <CourseDetails />}
                {courseSteps === 5 && <ClassSchedule />}
                {courseSteps === 6 && <Summary />}
            </CourseMainBox>
        </>
    )
}
